module.exports = __webpack_public_path__ + "static/media/screen-shot-2020-07-30-at-2-40-59-pm.60f80f0f.png";